// Fixes core's exact-full-href sidebar active-item matching (frappe/templates/includes/
// web_sidebar.html:59-73), which breaks on eshop pages: their own client-side filter/
// pagination logic (eshop/ui/views.js's change_route_with_filters) appends query params to
// the URL via pushState, even on first load, so the core JS's exact `this.href ==
// window.location.href` comparison fails and strips the active class it may have correctly
// set server-side. Scoped to body.product-page via a runtime check — other pages' native
// active-detection is untouched. Does not edit or remove the core logic.
window.addEventListener('load', () => {
	if (!document.body.classList.contains('product-page')) return;

	const normalize = (path) => (path || '')
		.split('?')[0]
		.split('#')[0]
		.replace(/^\/+|\/+$/g, '');

	// A page that has no tab of its own lights its parent's: the send log (/my-quote-sends), opened from
	// "My Quotes", and the pages "My Account" (/me) links to, a user's profile among them, whose path
	// holds the user (/update-profile/<user>, /update-profile/<user>/edit). Every other page matches its
	// own tab exactly, as before.
	const parent_paths = new Map([
		['my-quote-sends', 'my-quotes'],
		['update-password', 'me'],
		['third_party_apps', 'me'],
	]);
	const parent_prefixes = [['update-profile/', 'me']];
	const page_path = normalize(window.location.pathname);
	const prefixed = parent_prefixes.find(([prefix]) => page_path.startsWith(prefix));
	const current_path = parent_paths.get(page_path) || (prefixed ? prefixed[1] : page_path);

	// The sidebar's tabs, and their copy in the e-shop navbar's mobile menu (frappe's navbar_items.html).
	document.querySelectorAll('.sidebar-item a, .eshop-navbar .d-lg-none .nav-link').forEach((link) => {
		const link_path = normalize(link.getAttribute('href'));
		if (link_path && link_path === current_path) {
			link.classList.add('active');
		} else {
			link.classList.remove('active');
		}
	});
});
